/**
 * CustomHeaders is a collection of all custom-made
 * headers that clients can use.
 */
export enum CustomHeadersEnum {
  // Application mode
  X_APP_MODE = 'x_app_mode',
  // Application user authentication token
  X_APP_AUTH = 'x_app_auth',
}
